var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "90%",
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-card', _vm._g(_vm._b({
          staticClass: "common-metatag-list-item-code__activator",
          attrs: {
            "flat": "",
            "tile": "",
            "max-height": "240",
            "color": "transparent"
          }
        }, 'v-card', attrs, false), on), [_c('v-card-text', {
          staticClass: "px-4 py-3"
        }, [_c('code', {
          staticClass: "common-metatag-list-item-code__code"
        }, [_vm._v(_vm._s(_vm.item.code))])]), _c('div', {
          staticClass: "common-metatag-list-item-code__more d-flex justify-center align-end"
        }, [_c('v-card', {
          staticClass: "my-3 px-3 py-2 rounded-lg subtitle-2",
          attrs: {
            "outlined": ""
          }
        }, [_vm._v("더 보기")])], 1)], 1)];
      }
    }]),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(" 경로 \"" + _vm._s(_vm.item.path) + "\" 에 대한 코드 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function ($event) {
        _vm.shows = false;
      }
    }
  }, [_vm._v("mdi-close")])], 1), _c('v-card-text', [_c('code', {
    staticClass: "common-metatag-list-item-code__code"
  }, [_vm._v(_vm._s(_vm.item.code))])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }